import React from 'react';
import { Navigate, } from 'react-router-dom';
import AuthenticationService from '../../../service/AuthenticationService';

class NotFound extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  redirect() {
    if (AuthenticationService.isAuthenticated()) {
      this.setState({
        redirect: <Navigate to="/dashboard" replace />,
      });
    } else {
      this.setState({
        redirect: <Navigate to="/" replace />,
      });
    }
  }

  render() {
    const { redirect, } = this.state;
    return (
      <div className="container-fluid">
        <div className="justify-content-center" style={{ maxHeight: '200px', }}>
          <div className="row justify-content-center">
            <h1 className="text-primary">404 Not Found</h1>
          </div>
          <div className="row justify-content-center">
            <button
              type="button"
              className="btn btn-link underline"
              onClick={() => this.redirect()}
            >
              Return
            </button>
          </div>
        </div>
        {redirect}
      </div>
    );
  }
}

export default NotFound;
